import { createFileRoute } from '@tanstack/react-router'

import { PlatformAdminJobsPage } from '../../../../components/pages/backoffice/platform/platform-admin-jobs-page/platform-admin-jobs-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/admin/jobs/')({
  component: () => (
    <PermissionChecker requiredPermissions={['tech.configurations']}>
      <PlatformAdminJobsPage />
    </PermissionChecker>
  ),
})
